export default {
    label: 'Panel filter',
    empty: 'There are no evaluations yet'
}
